export default "__VITE_ASSET__CePOeZv9__"